document.addEventListener('DOMContentLoaded', () => {
  const MOBILE_WIDTH = 782;

  const header = document.querySelector('header');
  const navigation = document.querySelector('.navigation');
  const navigationMenuIcon = document.querySelector('.navigation__menu-icon');
  const navigationCloseIcons = document.querySelectorAll('.navigation__close-icon');
  const navigationNav = document.querySelector('.navigation__nav');
  const navigationTabsButtons = document.querySelectorAll('.navigation__nav__list__item.dropdown > a, .navigation__nav__list__item.dropdown > span');
  const prevIcons = document.querySelectorAll('.navigation__prev-icon');

  navigationMenuIcon.addEventListener('click', () => {
    const headerHeight = header.offsetHeight;

    navigation.classList.add('open');
    navigationNav.style.height = `calc(100vh - ${headerHeight}px)`;
    navigationNav.style.maxHeight = `calc(100vh - ${headerHeight}px)`;
    setTimeout(() => {
      navigationNav.style.overflowY = 'auto';
    }, 300);
  });

  navigationCloseIcons.forEach(icon => {
    icon.addEventListener('click', (e) => {
      const parentTab = e.target.closest('.navigation__nav__tab');
      if (parentTab) {
        parentTab.classList.remove('open');
      }
      navigation.classList.remove('open');
      navigationNav.style.height = '0';
      navigationNav.style.maxHeight = '0';
      navigationNav.style.overflowY = 'hidden';

    });

  });

  navigationTabsButtons.forEach(button => {
    const parent = button.closest('.navigation__nav__list__item.dropdown');
    const tab = parent.querySelector('.navigation__nav__tab');
    const isMobile = window.innerWidth < MOBILE_WIDTH;

    button.addEventListener('click', (event) => {
      if (isMobile) {
        event.preventDefault();
      }
      if (!tab.classList.contains('open')) {
        if (!isMobile) {
          const tab = parent.querySelector('.navigation__nav__tab');
          const tabContent = tab.querySelector('.navigation__nav__tab__content');
          const navList = document.querySelector('.navigation__nav__list');
  
          header.classList.add('dropdown-open');
          
          const buttonRect = button.getBoundingClientRect();
          const headerRect = header.getBoundingClientRect();
          const navListRect = navList.getBoundingClientRect();
          const distanceFromLeft = buttonRect.left - headerRect.left;
          const distanceFromRight = navListRect.left; // mirror
          
          const tabHeightsToCheck = [tabContent.scrollHeight];
  
          const maxHeight = Math.max(...tabHeightsToCheck);
  
          tabContent.style.paddingLeft = `${distanceFromLeft}px`;
          tabContent.style.paddingRight = `${distanceFromRight}px`;
          tabContent.style.height = `${maxHeight}px`;
          tabContent.style.maxHeight = `calc( 100vh - ${navigation.offsetHeight}px)`;
          setTimeout(() => {
            tabContent.style.overflowY = 'auto';
          }, 300);
  
          tab.style.top = `${header.offsetHeight}px`;
          tab.style.height = `calc(100vh - ${navigation.offsetHeight}px)`;
          tab.style.maxHeight = `calc(100vh - ${navigation.offsetHeight}px)`;
          document.body.classList.add('no-scroll');
        }
      } else {
        if (!isMobile) {
          const tab = parent.querySelector('.navigation__nav__tab');
          header.classList.remove('dropdown-open');
          tab.style.height = '0';
          tab.style.overflowY = 'hidden';
          document.body.classList.remove('no-scroll');
        }
      }

      if (!isMobile) {
        navigationTabsButtons.forEach(otherButton => {
          if (otherButton !== button) {
            otherButton.classList.remove('open');
            const otherTab = otherButton.closest('.navigation__nav__list__item.dropdown').querySelector('.navigation__nav__tab');
            if (otherTab) {
              otherTab.classList.remove('open');
              otherTab.style.height = '0';
              otherTab.style.overflowY = 'hidden';
            }
          }
        });
      }
      
      button.classList.toggle('open');
      tab.classList.toggle('open');
    });
  });

  prevIcons.forEach(icon => {
    icon.addEventListener('click', (e) => {
      const tab = e.target.closest('.navigation__nav__tab');
      tab.classList.remove('open');
    });
  });

  document.addEventListener('click', (event) => {
    const isClickInsideTab = event.target.closest('.navigation__nav__tab__content');
    const isClickInsideButton = event.target.closest('.navigation__nav__list__item.dropdown > a, .navigation__nav__list__item.dropdown > span');

    if (!isClickInsideTab && !isClickInsideButton) {
      navigationTabsButtons.forEach(button => {
        const tab = button.closest('.navigation__nav__list__item.dropdown').querySelector('.navigation__nav__tab');
        if (tab && tab.classList.contains('open')) {
          button.classList.remove('open');
          tab.classList.remove('open');
          tab.style.height = '0';
          tab.style.overflowY = 'hidden';
          document.body.classList.remove('no-scroll');
        }
      });
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth < MOBILE_WIDTH) {

      const tabs = document.querySelectorAll('.navigation__nav__tab');
      tabs.forEach(tab => {
        if (tab.classList.contains('open')) {
          header.classList.remove('dropdown-open');
          tab.style.height = '0';
          tab.style.overflowY = 'hidden';
          document.body.classList.remove('no-scroll');
        }
      })
    } else {
      if (navigation.classList.contains('open')) {
        navigation.classList.remove('open');
        navigationNav.style.height = 'auto';
        navigationNav.style.maxHeight = 'initial';
        setTimeout(() => {
          navigationNav.style.overflowY = 'hidden';
        }, 300);  
      }
    }
  });
});
